import { render, staticRenderFns } from "./BellButton.vue?vue&type=template&id=817ce6ca&scoped=true"
import script from "./BellButton.vue?vue&type=script&lang=js"
export * from "./BellButton.vue?vue&type=script&lang=js"
import style0 from "./BellButton.vue?vue&type=style&index=0&id=817ce6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817ce6ca",
  null
  
)

export default component.exports